module.exports = __webpack_public_path__ + "static/footer-boat-ee58b4a3e00ec15cd6ac938ade357628.svg";